<template>
  <v-app>
    <v-main>
      <Header v-if="!$route.meta.hideLayout" />
      <router-view />
      <Footer v-if="!$route.meta.hideLayout" />
    </v-main>
    <PwaInstallBanner v-if="!$route.meta.hideLayout" />
    <a
      v-if="!hideFloatingWidgets"
      :href="whatsappHref"
      class="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <v-icon color="white" size="30">mdi-whatsapp</v-icon>
    </a>
    <OhYesAi v-if="!hideFloatingWidgets" />
  </v-app>
</template>

<script>
import OhYesAi from "./components/OhYesAi.vue";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import PwaInstallBanner from "./components/PwaInstallBanner.vue";

export default {
  name: "App",
  components: {
    OhYesAi,
    Header,
    Footer,
    PwaInstallBanner,
  },
  computed: {
    hideFloatingWidgets() {
      return ["AddBookings", "AddBookingsUS"].includes(this.$route.name);
    },
    isUS() {
      return (
        this.$route.meta?.location === "us" ||
        this.$route.path?.startsWith("/us") ||
        localStorage.getItem("isUS") === "true"
      );
    },
    whatsappHref() {
      return this.isUS
        ? "https://wa.me/17082953912"
        : "https://wa.me/917356449135";
    },
  },
};
</script>

<style>
html,
body,
#app,
.v-application {
  background-color: #fff !important;
}

.whatsapp-float {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: #25d366;
  color: white;
  border-radius: 50%;
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  transition: all 0.3s ease;
  text-decoration: none;
}

.whatsapp-float:hover {
  background-color: #1ebe5d;
  transform: translateY(-3px);
}

/* Add padding to main content to account for fixed header */
.v-main {
  padding-top: 80px;
}
</style>
